var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmsDeliveryIcon = function SvgSmsDeliveryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 81 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#smsDeliveryIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M80.733 37.285c0 18.383-17.849 33.285-39.866 33.285-2.404 0-4.759-.178-7.045-.518-2.888-.43-5.853.38-8.187 2.134-.889.668-1.877 1.34-2.884 1.894-3.273 1.8-6.804 2.257-7.397 1.692-.592-.564 1.192-1.943 2.821-4.074.267-.348.526-.729.775-1.122 1.462-2.314.27-5.23-2.047-6.688C7.245 57.814 1 48.158 1 37.285 1 18.902 18.849 4 40.867 4s39.866 14.902 39.866 33.285"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "smsDeliveryIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5 0h80v80H.5z"
  })))));
};
export { SvgSmsDeliveryIcon as ReactComponent };